export default {
  header: {
    title: 'Køb gavekort',
  },
  items: {
    gift_card: {
      label: 'Gavekort',
      title: 'Vælg dit ønskede beløb',
      description: 'Læg gavekortet i kurven med det ønskede antal',
    },
    expiration: {
      label: 'Gyldigt i 3 år',
      title: 'God fornøjelse med at give gaver!',
      description: 'Modtageren kan indløse gavekortet fleksibelt inden for 3 år.',
    },
    delivery: {
      label: 'Levering med det samme som PDF via e-mail',
      title: 'Øjeblikkelig levering som PDF via e-mail',
      description: 'Efter sikker betaling med kreditkort, PayPal eller giropay modtager du gavekortet med det samme.',
    },
  },
  form: {
    value: {
      title: 'Vælg gavekortets beløb',
      custom: {
        label: 'Brugerdefineret',
        placeholder: 'Indtast beløb',
      },
    },
    quantity: {
      title: 'Antal',
    },
    email: {
      title: 'Hvad er din e-mailadresse, så vi kan sende dig gavekortet?',
      placeholder: 'Din e-mailadresse',
    },
  },
  confirmation: {
    title: {
      title: 'Opret gavekort?',
      subtitle_one: 'Vil du oprette 1 gavekort på {{value}}?',
      subtitle_other: 'Vil du oprette {{count}} gavekort på {{value}}?',
    },
    description: {
      total: 'I alt:',
      email: 'E-mail:',
      quantity: 'Antal',
      amount: 'Beløb',
    },
    footer: {
      cancel: 'Annuller',
      confirm: 'Bekræft',
    },
  },
  buttons: {
    create: 'Opret',
  },
  toasts: {
    error: 'Gavekortet kunne ikke oprettes.',
    success: 'Gavekortet blev oprettet.',
  },
};
